import { observable, action, makeObservable } from "mobx";
import ProvidersStore from "../../services/providers/ProvidersStore";

class RankingFiltersStore {
  state = {
    providers: [],
    allProviders: [],
    rankingType: "local",
    range: "Last3Months",
    startDate: null,
    endDate: null,
  };

  constructor() {
    makeObservable(this, {
      state: observable,
      setState: action
    });
  }

  setState(updates, callback) {
    Object.assign(this.state, updates);
    callback && callback();
  }

  getProviders(rankingType) {
    return rankingType === "local"
      ? ProvidersStore.localRankProviders
      : ProvidersStore.webRankProviders;
  }
}

const store = new RankingFiltersStore();

export default store;
